import React from "react";
import { format } from "date-fns";
import { cn } from "@/lib/utils";
import { useTime } from "@/hooks/useTime";

interface DashboardDateTimeProps {
  className?: string;
  timeClassName?: string;
  weekdayClassName?: string;
  dateClassName?: string;
}

export const DateTime: React.FC<DashboardDateTimeProps> = ({
  className,
  timeClassName,
  weekdayClassName,
  dateClassName,
}) => {
  const currentTime = useTime();

  const timeString = format(currentTime, "HH:mm");
  const weekdayString = format(currentTime, "EEEE");
  const dateString = format(currentTime, "d MMMM yyyy");

  return (
    <div className={cn("flex justify-end gap-2 items-center", className)}>
      <div className="text-eathy-comfort-1 font-geist text-base tracking-normal opacity-50">
        <span className={cn("font-normal", weekdayClassName)}>
          {weekdayString},{" "}
        </span>
        <span className={cn("font-semibold", dateClassName)}>{dateString}</span>
      </div>
      <span
        className={cn(
          "text-eathy-comfort-1 font-geist text-base font-semibold tracking-normal",
          timeClassName,
        )}
      >
        {timeString}
      </span>
    </div>
  );
};
